export default __webpack_public_path__ + "static/media/down-arrow.888e6dc6.svg";